import React, { useState, useEffect } from "react";
import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";

const LogoComponent = (props) => {

    const [parameters, setParameters] = useState(props.parameters ? props.parameters : null);
    const [isReadOnly, setIsReadOnly] = useState(props.isReadOnly);

    useEffect(() => {
        setParameters(props.parameters ? props.parameters : null);
        setIsReadOnly(props.isReadOnly);
    }, [props]);

    const align = (align) => {
        let params = {...parameters};
        params.ALIGNMENT = align;
        props.updateComponent(props.index, params);
    }

    return <div>
        <AlignButtons alignItems={align} getValue={props.getValue} alignment={parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
    </div>
}

export default LogoComponent;